module.exports = __webpack_public_path__ + "static/img/product3.639c9cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yellow/product3.png
// module id = vmoQ
// module chunks = 0